<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <!-- Table -->
    <p-table [columns]="cols"
             [value]="modifierGroups"
             [lazy]="true"
             (onLazyLoad)="handleLazyLoad($event)"
             [paginator]="true"
             [(first)]="first"
             [rows]="rowsPerPage"
             [rowsPerPageOptions]="rowsPerPageOptions"
             [totalRecords]="totalRecords"
             [resizableColumns]="true"
             [columnResizeMode]="'expand'"
             [autoLayout]="true"
             [styleClass]="'p-datatable-striped'"
             [scrollable]="true"
             [scrollHeight]="'flex'">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" class="search-input"
                           [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                           placeholder="Search..." />
                </span>
                <span>
                    <button pButton pRipple type="button" label="Create" class="p-button-success"
                            style="margin-right: 10px;" (click)="handleCreateModifierGroupClick()"></button>
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of cols"
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="col.disableSort"
                    pResizableColumn
                    [style.width]="col.width">
                    {{col.header}}
                    <p-sortIcon *ngIf="sortField===col.field" [field]="col.field"></p-sortIcon>
                </th>
                <th>Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-modifierGroup>
            <tr>
                <td *ngFor="let col of cols"
                    class="ui-resizable-column">
                    {{modifierGroup[col.field]}}
                </td>
                <td>
                    <span class="action-icon-svg" (click)="handleEditModifierGroupClick(modifierGroup)">
                        <img src="../Content/xpress-app/images/svg/icon_edit.svg" />
                    </span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
            <div *ngIf="modifierGroups.length > 0" style="padding-left: 10px">
                Displaying {{first + 1}} - {{first + modifierGroups.length}} of {{totalRecords}}
            </div>
        </ng-template>
    </p-table>
</div>

<edit-food-modifier-group *ngIf="showEditModifierGroupPopup"
                    [modifierGroupId]="editModifierGroupId"
                    [restaurants]="restaurants"
                    [onHide]="handleEditModifierGroupPopupHide"
                    [onSave]="handleEditModifierGroupPopupSave"></edit-food-modifier-group>

<p-toast position="top-right"></p-toast>
